import { createFileRoute, Outlet } from "@tanstack/react-router";
import { validateTradeInSearch } from "./-search-params";

/**
 * Pathless layout route for trade-in completion screens.
 * Groups: trade-in-options, trade-in-completion, store-locations, courier, etc.
 */
export const Route = createFileRoute("/$locale/$partner/_trade-in")({
	validateSearch: validateTradeInSearch,
	component: TradeInLayout,
});

function TradeInLayout() {
	return <Outlet />;
}
